import React from 'react';
import { Page } from 'components/layouts/components';
import { Flex, Tabs } from 'antd';
import Icon from '@mdi/react';
import { mdiAccountClock, mdiChartLine } from '@mdi/js';
import ActivityCard from './components/ActivityCard';
import InsightCard from './components/InsightCard';

const items = () => [
  {
    key: 'activity',
    label: (
      <Flex gap='small' align='center'>
        <Icon path={mdiAccountClock} size={0.8} />
        <span className='font-normal '>Activity</span>
      </Flex>
    ),
    children: <ActivityCard />,
  },
  {
    key: 'insights',
    label: (
      <Flex gap='small' align='center'>
        <Icon path={mdiChartLine} size={0.8} />
        <span className='font-normal'>Insights</span>
      </Flex>
    ),
    children: <InsightCard />,
  },
];

const InsightReportsPage = () => {
  return (
    <Page>
      <Tabs type='card' size='small' defaultActiveKey='activity' items={items()} />
    </Page>
  );
};

export default InsightReportsPage;
